import React from "react";
import "./qualification.css";
import { i18n } from "../translate/i18n";

export const Qualification = () => {
  return (
    <section className="qualification section">
      <h2 className="section__title">{i18n.t("quali.title")}</h2>
      <span className="section__subtitle">{i18n.t("quali.subtitle")}</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div className="qualification__button qualification__active button--flex">
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>
        </div>

        <div className="qualification__sections">
          <div className="qualification__content qualification__content-active">
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Ignite</h3>
                <span className="qualification__subtitle">
                  ReactJs | NodeJs | React Native - Rocketseat
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>{" "}
                  {i18n.t("quali.data1")}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Bootcamp</h3>
                <span className="qualification__subtitle">
                  Front end | Back end - Udemy
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>{" "}
                  {i18n.t("quali.data2")}
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Bootcamp</h3>
                <span className="qualification__subtitle">
                  Frontend | Backend - StartSe
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>{" "}
                  {i18n.t("quali.data3")}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  {i18n.t("quali.title2")}
                </h3>
                <span className="qualification__subtitle">
                  {i18n.t("quali.subtitle2")}
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2019 - 2020
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
